var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TInputRadio',{attrs:{"label":"Receivable for","list":_vm.list,"value":_vm.value,"custom":""},on:{"update:value":_vm.select}})
}
var staticRenderFns = []

export { render, staticRenderFns }